module.exports = __webpack_public_path__ + "img/soundstorm.9f4a668c.png";